function mergeMap(defaultMap = {}, currentMap = {}) {
  return {
    ...defaultMap,
    ...Object.keys(currentMap || {}).reduce((result, key) => {
      const value = currentMap[key];
      if (value !== null && typeof value !== "undefined") {
        result[key] = value;
      }
      return result;
    }, {}),
  };
}

export function mergeTemplate(defaultTemplate, currentTemplate) {
  const activeTemplate = currentTemplate || defaultTemplate || {};
  const baseTemplate = defaultTemplate || {};

  return {
    ...baseTemplate,
    ...activeTemplate,
    key: activeTemplate.key || baseTemplate.key,
    rawTemplate: activeTemplate,
    resources: mergeMap(baseTemplate.resources, activeTemplate.resources),
    pages: mergeMap(baseTemplate.pages, activeTemplate.pages),
    sections: mergeMap(baseTemplate.sections, activeTemplate.sections),
    checkout: mergeMap(baseTemplate.checkout, activeTemplate.checkout),
  };
}

export default mergeTemplate;
